import Vue from 'vue'

import axios from 'axios'
import store from '@/store/index'
import router from '@/router'

const axiosIns = axios.create({

  // baseURL: 'http://localhost:8000/api',
  baseURL: 'https://api-staging.aequitex.com/api',
  // baseURL: 'https://api.aequitex.com/api',

  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json',
    Authorization: `Bearer ${store.state.auth.token}`,
  },
})





















axiosIns.interceptors.request.use(
    config => {
        const token = store.state.auth.token
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    error => Promise.reject(error)
)

axiosIns.interceptors.response.use(
     response => response,
    error => {
        if (error.response && error.response.status === 401) {
            if (error.config.url && error.config.url.includes('/admin-register/')) {
                return Promise.reject(error)
            }

            const logout = () => {
                store.commit('auth/SET_USER', null)
                store.commit('auth/SET_AUTHENTICATED', false)
                store.commit('auth/UPDATE_TOKEN', null)

                if (router.currentRoute.name !== 'login') {
                    router.push({ name: 'login' })
                }
            }

            if (error.config.url && error.config.url.includes('/check_login_trigger_self')) {
                if (router.currentRoute.path.includes('admin-register') || router.currentRoute.name?.includes('admin-register')) {
                    return Promise.reject(error)
                }
                logout();
                return Promise.reject(error)
            }

            axiosIns
                .post(`/check_login_trigger_self`)
                .then(res => {
                    if(res.data.value.shouldLogOut) {
                        logout();
                    }
                })
         }
        return Promise.reject(error)
    }
)

Vue.prototype.$http = axiosIns

export default axiosIns
